var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnotations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "qlaagzp8wa",
    d: "M12.63 3.63l.021.021 7.561 7.561.158.158c.42.42.632 1.006.577 1.598l-.02.19C20.356 17.582 16.577 21 12 21c-4.97 0-9-4.03-9-9 0-4.608 3.463-8.407 7.928-8.937l.09-.01c.596-.059 1.188.153 1.611.576zM10.573 5c-1.074 2.809-.64 5.184 1.3 7.125 1.878 1.877 4.16 2.345 6.847 1.403l.279-.102L10.574 5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-940 -1768) translate(940 1768)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8katmdaxrb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qlaagzp8wa"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#8katmdaxrb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotations);
export default __webpack_public_path__ + "static/media/annotations.35a74e17e3c506a99d2020bc0670561a.svg";
export { ForwardRef as ReactComponent };